module.exports = __webpack_public_path__ + "static/corgy-porgy-1a7f7942d3e25c02777027f3aca64020.png";